/**
 * Classe model pour l'écran de fin
 */
export class PageFinModel {

     /**
     * 
     */
    nombreEnfantMoinsXXansAvecRevenusSuperieur: number;

    /**
     * 
     */
    codePostal: number;
 
    /**
     * 
     */
    seuilAge: number;

     /**
     * Valeurs possibles : 
     * true = droit prestation possible d'après la simulation
     * false = pas de droit prestation possible d'après la simulation
     */
    possedeDesDroits: boolean;

    /**
     * 
     */
    montantDroit: number;


    /**
     * Constructeur
     */
    constructor() { }
}
